export { default } from './ReportContent';
